module.exports = __webpack_public_path__ + "static/media/ico-sdsm-inactive.113b19ed.svg";